import { useEffect } from 'react';
import SureLoader from '../Components/SureLoader';
import { useAuth } from '../Contexts/AuthContext';

function AuthGuard({ children }) {
  const { initialized, isAuthenticated, isLoading, error, login } = useAuth();

  useEffect(() => {
    console.log('AuthGuard - initialized:', initialized);
    console.log('AuthGuard - authenticated:', isAuthenticated);

    if (!initialized) return;
    if (isAuthenticated) return;

    login({ redirectTo: window.location.href });
  }, [initialized, isAuthenticated, login]);

  if (!initialized || isLoading) {
    return <SureLoader fullscreen />;
  }

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}

export default AuthGuard;
